module.exports = __webpack_public_path__ + "py.3fdd777320df21497ef6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/py.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/py.svg
// module chunks = styles